<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>환불규정</h3>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="box">
                                <div class="row">
                                    <div class="col-lg-12 mt-5">
                                        <div class="line-dot">
                                            <dl class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#128176;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>환불금액</strong></dd>
                                                <dd>출항 5일전 100%환불</dd>
                                                <dd>출항 4일전 50%환불</dd>
                                                <dd>출항 3일전 30%환불</dd>
                                                <dd>출항 2일전부터 환불불가</dd>
                                                <dd><span class="font-red"><b>※ 환불문의는 전화로 부탁드립니다</b></span></dd>
                                            </dl>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 mt-5">
                                        <div class="line-dot">
                                            <dl class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#128680;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>유의사항</strong></dd>
                                                <dd>▶출조점에서 모든 미끼.채비 등등 구입 가능 합니다.</dd>
                                                <dd>※선박 이용 지침 사항</dd>
                                                <dd>▶​기상악화와 최소인원 미달시 출조 취소될수 있는점 ​양해 부탁드립니다.</dd>
                                                <dd>▶출항시간은 일정에 따라 변동될수 있습니다.</dd>
                                                <dd>▶승선시 신분증은 꼭 지참해 주세요(미지참시 승선이 불가합니다)</dd>
                                                <dd>▶구명조끼 반드시 착용하여야합니다. (미착용 승선시 과태료 100만원)</dd>
                                                <dd>▶선박 내 음주 불가능합니다.</dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.line-dot{
    display: flex;
    border-top-width: 0px;
    border-right-width: 0px;
    border-left-width: 0px;
    border-bottom: 1px rgb(204, 204, 204);
    border-style: dashed;
    height: 100%;
}

.line-dot > .icon > i {
    width: 64px;
}
</style>
